import {
  FETCH_SUBMIT_COMPLETE_TASK_REQUEST,
  FETCH_SUBMIT_COMPLETE_TASK_SUCCESS,
  FETCH_SUBMIT_COMPLETE_TASK_FALUIRE,
} from './submitCompleteTaskTypes'

const initialState = {
  loading: false,
  submitCompleteTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_SUBMIT_COMPLETE_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_SUBMIT_COMPLETE_TASK_SUCCESS : return {
      ...state,
      submitCompleteTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_SUBMIT_COMPLETE_TASK_FALUIRE : return {
      ...state,
      loading: false,
      submitCompleteTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
